<template>
  <div class="avatar-upload">
    <div class="avatar-preview">
      <div
        v-if="coverImgUrl"
        v-bind:style="{
          backgroundImage: 'url(' + coverImgUrl + ')'
        }"
      ></div>
      <div v-else>
        <i :class="fontAwClass" class="fs-12000 text-primary"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AvatarPreview',
  props: ['coverImgUrl', 'fontAwClass'],
  data() {
    return {}
  }
}
</script>
 